import { render, staticRenderFns } from "./QuickRecovery.vue?vue&type=template&id=38a51df2"
import script from "./QuickRecovery.vue?vue&type=script&lang=js"
export * from "./QuickRecovery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports